import validate from "/home/node/node_modules/nuxt/dist/pages/runtime/validate.js";
import mobile_45only_45redirect_45global from "/home/node/middleware/mobile-only-redirect.global.ts";
import manifest_45route_45rule from "/home/node/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  mobile_45only_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/node/middleware/auth.ts")
}